export const filterObject = (obj, condition) => {
  return Object.keys(obj).reduce((filteredObj, key) => {
    if (condition(obj[key], key)) {
      filteredObj[key] = obj[key];
    }
    return filteredObj;
  }, {});
}